module.exports = __webpack_public_path__ + "static/scale-model-of-pedal-wagon-dayton-in-dayton-ohio-e77f43af4c7901de77d4dc6a8b090d86.png";